import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";

function AppShell() {
  const info = useSelector((state: any) => state.info);

  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (!info?.kycDone) {
        event.preventDefault();
        event.returnValue = "Are you sure you want to exit?";
        return "Are you sure you want to exit?";
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [info?.kycDone]);
  return <Outlet />;
}

export default AppShell;
